import { isOptInExperienceEnabledForScenario } from "owa-copilot-settings-store";
import type { MailboxInfo } from "owa-client-types";

export default function isOptInExperienceEnabledForPrioritize(mailboxInfo: MailboxInfo): boolean {
    return isOptInExperienceEnabledForScenario("Inbox", mailboxInfo);
}
